import SVG from 'svg.js';
import 'svg.draw.js';
import 'svg.select.js';
import 'svg.resize.js';
import '@/core/plugins/svg.draw.js';
import 'svg.draggable.js';
// import 'svg.panzoom.js';
import { createApp, defineComponent, h } from 'vue';
// import VueMaterial from './components/ui/vendor/core/index.js';
// import 'vue-material/dist/vue-material.css';
// importing assets
import '@/assets/fonts.css';
// import '@material-design-icons/font';
import '@/assets/styles.scss';
// import '@/assets/seatmap.scss';

// or
import { plugin as VueTippy } from 'vue-tippy';
import 'tippy.js/dist/tippy.css'; // optional for styling

// application's imports
import { RENDERER_MODE, CHANNEL } from '@/constants';
import App from './App.vue';
import store, { Store } from './store/store';
import Application, { AppProps } from '@/core/application';
import { initSeatmap } from './initSeatmap';

if (RENDERER_MODE) {
  import('@/assets/renderer/renderer.scss');
} else {
  import('@/assets/seatmap.scss');
}

declare module 'vue' {
  interface ComponentCustomProperties {
    $app: Application;
    $store: Store;
  }
}

declare global {
  interface Window {
    appConfig: AppData;
    app: Application;
    onbeforeunload: any;
  }
}

type AppData = {
  designerdata: AppProps;
  rendererdata: AppProps;
};

const migrateZonesToSections = (appdata: AppProps) => {
  if (appdata?.options?.layouts) {
    appdata.options.layouts = appdata.options.layouts.map((option) => (option === 'Zones' ? 'Sections' : option));
  }
};

const INIT_CHECK_INTVL = setInterval(() => {
  if (
    window.appConfig !== undefined &&
    (window.appConfig.designerdata !== undefined || window.appConfig.rendererdata !== undefined)
  ) {
    clearInterval(INIT_CHECK_INTVL);
    const appdiv = document.createElement('div');
    appdiv.setAttribute('id', 'app');
    document.body.appendChild(appdiv);
    let appdata = window.appConfig.designerdata;
    if (RENDERER_MODE) {
      document.body.classList.add('renderer');
      appdata = window.appConfig.rendererdata;
    }

    migrateZonesToSections(appdata);

    const svg = SVG(appdata.domELM);
    const app = new Application(svg, appdata);

    window.app = app;

    initSeatmap(app);

    const appComp = defineComponent({
      mounted: function () {
        window.onbeforeunload = function () {
          if (RENDERER_MODE) {
            app.props.onClose();
          } else if (app.unsavedChanges && !import.meta.env.DEV) {
            return 'Are you sure you want to close the window?';
          }
        };
        if (RENDERER_MODE) {
          if (app.props.isShowLocks && (app.props.channel === CHANNEL.POS || app.props.channel === CHANNEL.REPORTING)) {
            document.body.classList.add('lock-show');
          } else {
            document.body.classList.add('lock-hide');
          }
          const spinner = document.getElementById('appspinner');
          if ((app.props.isShowLoading && typeof spinner == 'undefined') || spinner == null) {
            const loaderDiv = document.createElement('div');
            loaderDiv.setAttribute('id', 'appspinner');
            document.body.appendChild(loaderDiv);
          }
        }
      },
      render: () => h(App),
    });

    const vueApp = createApp(appComp).use(VueTippy, { a11y: false }).use(store);
    vueApp.config.globalProperties.$app = app;

    // Add all components from folder /src/components/ui/legacy. Use import.meta.globEager to import all files
    // from folder and then register them as components
    const components = import.meta.globEager('./components/ui/legacy/*.vue') as any;
    for (const path in components) {
      vueApp.component(components[path].default.name ?? components[path].default.__name, components[path].default);
    }

    vueApp.mount('#app');
  }
}, 100);
